// 수신자료관리 - ERP_자재정보조회
import { Route, Switch } from 'react-router-dom';
import { lazy, Suspense } from 'react';


const REPD0 = lazy(() => import('@/pages/B02/REPD0'));
const REPD1 = lazy(() => import('@/pages/B02/REPD1'));
const REPD2 = lazy(() => import('@/pages/B02/REPD2'));
const REPD3 = lazy(() => import('@/pages/B02/REPD3'));
const REPD9 = lazy(() => import('@/pages/B02/REPD9'));
const REPDH = lazy(() => import('@/pages/B02/REPDH'));
const RKDD0 = lazy(() => import('@/pages/B02/RKDD0'));
const RKDD1 = lazy(() => import('@/pages/B02/RKDD1'));
const RKDD2 = lazy(() => import('@/pages/B02/RKDD2'));
const RKDD9 = lazy(() => import('@/pages/B02/RKDD9'));

function B02() {
  return ( 
    <Suspense fallback={null}>
      <Switch>
        <Route path="/B02/REPD0" component={REPD0} />
        <Route path="/B02/REPD1" component={REPD1} />
        <Route path="/B02/REPD2" component={REPD2} />
        <Route path="/B02/REPD3" component={REPD3} />
        <Route path="/B02/REPD9" component={REPD9} />
        <Route path="/B02/REPDH" component={REPDH} />
        <Route path="/B02/RKDD0" component={RKDD0} />
        <Route path="/B02/RKDD1" component={RKDD1} />
        <Route path="/B02/RKDD2" component={RKDD2} />
        <Route path="/B02/RKDD9" component={RKDD9} />
      </Switch>
    </Suspense>
  );
}

export default B02;
